<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(:title='device.deviceName', left-arrow, @click-left='$emit("closeView")')

  .main.addUnit__infoMain
    .addUnit__title {{ $t("addUnit.info.info") }}
    van-cell-group.addUnit__popup__cell-group
      van-cell(:title='$t("addUnit.info.mac")', :value='device.mac')
      van-cell(v-if="device.ip" :title='$t("addUnit.info.ip")', :value='device.ip')
      van-cell(:title='appName !== "dknna" ? $t("addUnit.info.wsVersion") : $t("unit.firmDKN")', @click='checkVersion')
        template(slot='right-icon')
          span.van-cell-text {{ device.wsver }}
          VersionStateIcon.margin-quarter-left.no-margin-right(:state='fwVersionState', v-if="appName === 'dknna' && hasOTA")
      van-cell(v-if="appName !== 'dknna'" :title='$t("addUnit.info.mVersion")', :value='device.mver')
      van-cell(v-if='device.isDeviceConnectedToWifi', :title='$t("addUnit.info.wifi")')
        template(slot='right-icon')
          span.van-cell-text {{ device.wifi }}
          Coverage.margin-quarter-left.no-margin-right(:signal='device.rssi')
      van-cell.addUnit__protocol-row(
        v-if='protocol && !hasRS485Mode',
        :title='$t("protocol.title")',
        :value='protocol',
        @click='openProtocol',
        is-link
      )
      van-cell.addUnit__protocol-row(
        v-if='showFallback && fallback',
        :title='$t("fallback.title")',
        @click='openFallback',
        is-link
      )
      van-switch-cell(
        v-if='device.ledsoff !== undefined',
        v-model='ledsOn',
        :title='$t("unit.ledsOff")',
        @change='updateLeds'
      )
      van-cell.addUnit__protocol-row(
        v-if='auxheat',
        :title='$t("auxheat.title")',
        @click='openAuxheat',
        is-link
      )
      van-cell.addUnit__protocol-row(
        v-if='digitalInput',
        :title='$t("digitalInput.title")',
        @click='openDigitalInput',
        is-link
      )
      van-cell.addUnit__protocol-row(
        v-if="appName === 'dknna' && hasIntegration",
        :title='$t("new3.unit.integration")',
        @click='openIntegrations',
        is-link
      )

    .addUnit__title {{ $t("addUnit.info.status") }}
    van-cell-group.addUnit__popup__cell-group
      van-cell
        template(slot='title')
          van-icon(name='unit', :class='{ "text-brand": device.isDeviceConnectedToUnit }')
          span.van-cell-text.text-gray2(v-if='device.isDeviceConnectedToUnit') {{ $t("addUnit.info.unitConnection") }}
          span.van-cell-text.text-gray2(v-if='!device.isDeviceConnectedToUnit') {{ $t("addUnit.info.notUnitConnection") }}
      van-cell(:is-link="appName === 'dknna'", @click="changeNetwork")
        template(slot='title')
          van-icon(name='wifi', :class='{ "text-brand": device.isDeviceConnectedToWifi }')
          span.van-cell-text.text-gray2(v-if='device.isDeviceConnectedToWifi') {{ $t("addUnit.info.wifiConnection") }}
          span.van-cell-text.text-gray2(v-if='!device.isDeviceConnectedToWifi') {{ $t("addUnit.info.notWifiConnection") }}
      van-cell
        template(slot='title')
          van-icon(name='cloud', :class='{ "text-brand": device.isDeviceConnectedToCloud }')
          span.van-cell-text.text-gray2(v-if='device.isDeviceConnectedToCloud') {{ $t("addUnit.info.cloudConnection") }}
          span.van-cell-text.text-gray2(v-if='!device.isDeviceConnectedToCloud') {{ $t("addUnit.info.notCloudConnection") }}
      van-cell(:is-link="appName == 'dknna'", @click="checkAssociated")
        template(slot='title')
          van-icon(
            name='users',
            :class='{ "text-brand": device.isDeviceAssociated, "text-gray4": !device.isDeviceAssociated }'
          )
          span.van-cell-text.text-gray2(v-if='device.isDeviceAssociated') {{ $t("addUnit.info.associated") }}
          span.van-cell-text.text-gray3(v-if='!device.isDeviceAssociated') {{ $t("addUnit.info.notAssociated") }}

    .addUnit__title(v-if='showTestActions && device.isDeviceConnectedToUnit') {{ $t("new3.addUnit.info.testActions") }}

    .buttom-action-group(v-if='showTestActions && device.isDeviceConnectedToUnit')
      .button-action(@click='testDevice("testonheat")') {{ $t("new3.addUnit.info.testonheat") }}
      .button-action(@click='testDevice("testoncool")') {{ $t("new3.addUnit.info.testoncool") }}
      .button-action(v-if='!device.altherma', @click='testDevice("testonfan")') {{ $t("new3.addUnit.info.testonfan") }}
      .button-action(@click='testDevice("testoff")') {{ $t("new3.addUnit.info.testoff") }}

  .button-bottom-group(:class='{ "button-bottom-group--double": device.isDeviceConnectedToWifi }', v-if="appName !== 'dknna'")
    .button-bottom(v-if='!device.isDeviceConnectedToWifi', @click='changeNetwork')
      | {{ $t("addUnit.info.connectNetwork") }}
    .button-bottom(v-if='device.isDeviceConnectedToWifi', @click='changeNetwork')
      | {{ $t("addUnit.info.changeNetwork") }}
    .button-bottom(
      v-if='device.isDeviceConnectedToWifi && !device.isDeviceAssociated && device.isDeviceConnectedToCloud',
      @click='associatedDevice'
    )
      | {{ $t("addUnit.info.associate") }}
    .button-bottom.text-danger(v-if='device.isDeviceAssociated', @click='checkReleaseDevice')
      | {{ $t("addUnit.info.release") }}

  //- Device Connect Protocol
  van-popup.van-popup--full(v-model='showModalProtocol')
    DeviceProtocol(v-if='showModalProtocol', :device='device', @close='closeProtocol')

  //- Device Fallaback
  van-popup.van-popup--full(v-model='showModalFallback')
    DeviceFallback(v-if='showModalFallback', :device='device', @close='closeFallback')

  //- Device Auxiliary Heat
  van-popup.van-popup--full(v-model='showModalAuxheat')
    DeviceAuxheat(v-if='showModalAuxheat', :device='device', @close='closeAuxheat')

  //- Device Digital Input
  van-popup.van-popup--full(v-model='showModalDigitalInput')
    DeviceDigitalInput(v-if='showModalDigitalInput', :device='device', @close='closeDigitalInput')

  //- Device Integrations
  van-popup.van-popup--full(v-model='showModalIntegrations')
    DeviceIntegrations(v-if='showModalIntegrations', :device='device', @close='closeIntegrations')

  //- Associate Device
  van-popup.addUnit__popup.addUnit__popup--associate(v-model='showModalAssociate')
    ManageDevices(
      v-if='showModalAssociate',
      :mac='device.mac',
      :altherma='device.altherma',
      @successAssociate='successAssociate',
      @close='closeAssociated'
    )

  //- Connect Device
  van-popup.addUnit__popup.addUnit__popup--connect(v-model='showModalConnect')
    DeviceConnect(v-if='showModalConnect', :device='device', :connectedToWifi="device.isDeviceConnectedToWifi" @closeModal='closeConnect')

  //-
  van-popup.unit__webserver__popup(v-model='showUpdateVersionDevice')
    .deviceModalVersionUpdate
      .van-popup__header {{ $t('home.updateTitle') }}

      van-cell-group.versionText
        van-cell(
          :value="getVersionMessage")

      .addUnit__popup__buttons
        .addUnit__popup__button(@click="showUpdateVersionDevice = false")
          | {{ $t('home.notNow') }}
        .addUnit__popup__button.updateButton(@click="startTimeout(240000)")
          | {{ $t('home.update') }}
        //- duplicamos el tiempo porque puede tardar más

  //-
  van-popup.unit__webserver__popup(v-model='showRequiredInternet')
    .deviceModalVersionUpdate
      .van-popup__header {{ $t('home.noInternet') }}

      van-cell-group.versionText
        van-cell(
          :value="$t('home.requiredInternet')")

      .popup__button.popup__button--confirm(@click="showRequiredInternet = false")
        | {{ $t('new3.auth.device.close') }}

</template>

<script>
import i18n from '@/locales/i18n';
import BluetoothService from '@/services/bluetooth.service';
import InstallationService from '@/services/installation.service';
import DeviceConnect from '@/components/AddUnit/DeviceConnect.vue';
import DeviceProtocol from '@/components/AddUnit/DeviceProtocol.vue';
import DeviceFallback from '@/components/AddUnit/DeviceFallback.vue';
import DeviceAuxheat from '@/components/AddUnit/DeviceAuxheat.vue';
import DeviceDigitalInput from '@/components/AddUnit/DeviceDigitalInput.vue';
import DeviceIntegrations from '@/components/AddUnit/DeviceIntegrations.vue';
import ManageDevices from '@/components/Units/ManageDevices.vue';
import Coverage from '@/components/Coverage.vue';
// import UpdatingDevice from '@/components/UpdatingDevice/UpdatingDevice.component.vue';
import UpdatingDeviceMixin from '@/mixins/updatingDevice.mixin';
import { getErrorId } from '@/services/error.service';
import { CONFIG, APPNAME } from '@/app.config';
import { hasProp } from '@/utils/validate.utils';
import VersionStateIcon from '@/components/VersionStateIcon';

export default {
  mixins: [UpdatingDeviceMixin],
  components: {
    DeviceConnect,
    DeviceProtocol,
    DeviceFallback,
    DeviceAuxheat,
    DeviceDigitalInput,
    DeviceIntegrations,
    ManageDevices,
    Coverage,
    VersionStateIcon,
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
    pin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      wifis: [],
      ledsOn: !this.device.ledsoff,
      showModalAssociate: false,
      showModalConnect: false,
      showModalProtocol: false,
      showModalFallback: false,
      showModalAuxheat: false,
      showModalDigitalInput: false,
      showModalIntegrations: false,
      showRequiredInternet: false,
      showUpdateVersionDevice: false,
      showTestActions: CONFIG.TEST_ACTIONS,
      showModbus: CONFIG.MODBUS,
      showFallback: CONFIG.FALLBACK,
      testError: null,
      releaseError: null,
      isLoading: false,
      appName: APPNAME,
      hasOTA: true,
    };
  },

  computed: {
    hasRS485Mode() {
      return (
        this.device.rs485_availablemodes &&
        (this.device.rs485_availablemodes.includes(0) ||
          this.device.rs485_availablemodes.includes(1))
      );
    },

    protocol() {
      if (this.device.bacneton) return this.$i18n.t('protocol.bacnet');
      if (this.device.modbusaddr >= 0) return this.$i18n.t('protocol.modbus');
      return null;
    },

    fallback() {
      return hasProp(this.device, 'gpioalpha');
    },

    auxheat() {
      return hasProp(this.device, 'auxheat_enable');
    },

    digitalInput() {
      return hasProp(this.device, 't1t2_enable');
    },

    hasIntegration() {
      return (
        hasProp(this.device, 'rs485_mode') ||
        hasProp(this.device, 'lapi') ||
        hasProp(this.device, 'venstar') ||
        hasProp(this.device, 'ecobeesb') ||
        hasProp(this.device, 'pelican')
      );
    },
  },

  methods: {
    /*
     * Modifico el puerto modbus
     */
    async updateLeds() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Preparo los datos
        const data = {};
        data.ledsoff = this.ledsOn ? 0 : 1;

        // Realizo la petición
        await BluetoothService.setExtrainfo(this.device.id, JSON.stringify(data));
        await BluetoothService.getDeviceInfo(this.device.id);

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message:
            this.appName === 'dknna'
              ? i18n.t('protocol.ledsSuccess')
              : i18n.t('new3.addUnit.info.testSuccess'),
        });
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({
          mask: true,
          message:
            this.appName === 'dknna'
              ? i18n.t('protocol.ledsError')
              : i18n.t('new3.addUnit.info.testError'),
        });
      } finally {
        this.isLoading = false;
      }
    },

    /*
     * Check if device is associated to show release modal or associate view
     */
    checkAssociated() {
      console.log('checkAssociated');
      if (
        this.device.isDeviceConnectedToWifi &&
        !this.device.isDeviceAssociated &&
        this.device.isDeviceConnectedToCloud
      ) {
        this.associatedDevice();
      } else if (this.device.isDeviceAssociated) {
        this.checkReleaseDevice();
      }
    },

    /*
     * Associated device
     */
    associatedDevice() {
      this.showModalAssociate = true;
    },

    successAssociate(device) {
      this.device.installationID = device.installation_id;
      this.device.isDeviceAssociated = true;
      this.showModalAssociate = false;
    },

    /*
     * Associated device
     */
    closeAssociated() {
      this.showModalAssociate = false;
    },

    openProtocol() {
      this.showModalProtocol = true;
    },

    closeProtocol(data) {
      Object.assign(this.device, data);
      this.showModalProtocol = false;
    },

    openFallback() {
      this.showModalFallback = true;
    },

    closeFallback(data) {
      Object.assign(this.device, data);
      this.showModalFallback = false;
    },

    openAuxheat() {
      this.showModalAuxheat = true;
    },

    closeAuxheat(data) {
      Object.assign(this.device, data);
      this.showModalAuxheat = false;
    },

    openDigitalInput() {
      this.showModalDigitalInput = true;
    },

    closeDigitalInput(data) {
      Object.assign(this.device, data);
      this.showModalDigitalInput = false;
    },

    openIntegrations() {
      this.showModalIntegrations = true;
    },

    closeIntegrations(data) {
      Object.assign(this.device, data);
      this.showModalIntegrations = false;
    },

    /*
     * Test device action
     */
    async testDevice(action) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.testError = null;

        await BluetoothService.testDevice(this.device.id, action);

        this.$toast.clear();
        this.$toast.success({ mask: true, message: i18n.t('new3.addUnit.info.testSuccess') });
      } catch (error) {
        // Obtengo el error
        this.testError = getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: i18n.t('new3.addUnit.info.testError') });
      } finally {
        this.isLoading = false;
      }
    },

    /*
     * Show modal to set new wifi connection
     */
    changeNetwork() {
      this.showModalConnect = true;
    },

    /*
     * Close modal to set new wifi connection
     */
    async closeConnect(data) {
      this.device.mver = data.mver;
      this.device.wsver = data.wsver;
      this.device.wifi = data.wifi;
      this.device.rssi = data.rssi;
      this.device.ip = data.ip;
      this.device.isDeviceConnectedToWifi = data.isDeviceConnectedToWifi;
      this.device.isDeviceConnectedToCloud = data.isDeviceConnectedToCloud;
      await this.initVersion();
      this.showModalConnect = false;
    },

    checkReleaseDevice() {
      this.$dialog
        .confirm({
          title: i18n.t('addUnit.info.releaseMsg.title'),
          message: i18n.t('addUnit.info.releaseMsg.message'),
        })
        .then(() => {
          this.releaseDevice();
        });
    },

    /*
     * Release device
     */
    async releaseDevice() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        const device = {};
        device.mac = this.device.mac;
        if (this.pin) device.pin = this.pin;
        if (this.device.installationID) device.installation_id = this.device.installationID;

        // Realizo la petición
        await InstallationService.releaseDevice(device);

        this.device.isDeviceAssociated = false;
        this.$toast.clear();
        this.$toast.success(i18n.t('addUnit.info.releaseUnitSuccess.message'));
      } catch (error) {
        // Obtengo el error
        const releaseError = getErrorId(error);

        this.$toast.clear();

        const errorID = i18n.te(`errors.${releaseError}.title`) ? releaseError : 'default';

        this.$dialog.alert({
          title: i18n.t(`errors.${errorID}.title`),
          message: i18n.t(`errors.${errorID}.message`),
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
